<template>
  <div class="c-header-utility__item c-alert">
    <div
      v-if="alert && alert.fields && alert.fields.color"
      class="c-alert__title"
      :class="'c-alert__level--' + alert.fields.color.value.toLowerCase()"
      @click="openAlert"
    >
      Alert Level:
      <span class="c-alert__option" v-if="alert && alert.fields && alert.fields.threatLevel">
        {{ alert.fields.threatLevel.value.toLowerCase() }}
      </span>
      <span class="c-alert__button"></span>
    </div>
    <transition name="reveal">
      <div
        v-if="alert && alert.fields && alert.fields.color && isAlertOpen"
        class="c-alert__message"
        :class="['c-alert__level--' + alert.fields.color.value.toLowerCase()]"
      >
        <div class="c-alert__title">
          Alert Level:
          <span class="c-alert__option" v-if="alert && alert.fields && alert.fields.threatLevel">
            {{ alert.fields.threatLevel.value.toLowerCase() }}
          </span>
        </div>
        <button class="c-alert__close" @click="closeAlert">&#215;</button>
        <div class="c-alert__content">
          <p v-if="alert && alert.fields && alert.fields.alertLevelDescription">
            {{ alert.fields.alertLevelDescription.value.split('.')[0] }}.
          </p>
          <a href="/cybersecurity-threats/" class="c-cta--secondary">More Details</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CIS-Alert',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      isAlertOpen: false
    };
  },
  computed: {
    alert() {
      return this && this.fields && this.fields.alert;
    },
    test() {
      return document.location;
    }
  },
  methods: {
    openAlert() {
      this.isAlertOpen = true;
    },
    closeAlert() {
      this.isAlertOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-alert {
  position: relative;
  overflow: visible;
  display: inline-block;

  @include desktop-up {
    display: inherit;
  }

  &__title {
    display: inline-block;
    @include font-styles('Arial Narrow', 1.8rem, 400, normal, 2.2rem, 0, $black);
    border-radius: 0.5rem;
    padding: 0.8rem 1.5rem;
    background-color: $white;
    cursor: pointer;

    @include desktop-up {
      padding: 0.5rem 1.3rem 0.5rem 1.3rem;
      font-size: 1.6rem;
      line-height: 1.9rem;
    }
  }

  &__option {
    font-weight: 700;
    text-transform: capitalize;
  }

  &__button {
    position: relative;
    display: inline-block;
    width: 1.4rem;
    height: 1.4rem;
    top: 0.1rem;
    background: url(~@/assets/images/icon-info.svg) no-repeat;
    margin-left: 0.9rem;
  }

  &__message {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    top: -3.8rem;
    right: 0;
    width: calc(100% - 4rem);
    z-index: 1;
    border-radius: 0.5rem;
    padding: 1.4rem;
    text-align: left;
    background-color: $white;
    transform-origin: 1% 1%;
    transition-timing-function: cubic-bezier(0, 0, 0.58, 1);

    @include desktop-up {
      position: absolute;
      top: 0;
      width: 70rem;
      transform-origin: 99% 1%;
    }

    .c-alert__title {
      padding: 0;
      background-color: transparent;
    }

    .c-alert__button {
      cursor: initial;
    }

    .c-alert__close {
      font-size: 2.25rem;
      margin: -1.75rem -0.5rem 0 0;
      line-height: 0;
      background-color: transparent;
      border: none;
      padding: 0;
      cursor: pointer;

      @include desktop-up {
        margin-right: -0.25rem;
        margin-top: 0;
      }
    }
  }
  .reveal {
    &-enter,
    &-leave {
      &-active {
        transition: transform 0.3s cubic-bezier(0, 0, 0.36, 1);
      }
    }

    &-enter,
    &-leave-to {
      transform: scale(0);
    }
  }

  &__content {
    display: flex;
    flex-basis: 100%;
    font-size: 1.4rem;
    line-height: 2rem;
    flex-wrap: wrap;

    @include desktop-up {
      flex-wrap: initial;
      font-size: 1.2rem;
      line-height: 1.6rem;
    }

    p {
      font-size: 1.4rem;
      line-height: 1.8rem;
      margin: 1rem 0;

      span {
        font-size: 1.2rem;
        line-height: 1.6rem;
      }
    }

    .c-button {
      color: inherit;
      border-color: inherit;
      white-space: nowrap;
      align-self: center;
      font-size: 1.6rem;
      line-height: 1.4rem;
      padding-left: 1rem;
      padding-right: 2rem;

      @include desktop-up {
        margin-left: 2rem;
        margin-right: 5rem;
        line-height: 2.2rem;
        padding-right: 2.8rem;
      }

      &:hover {
        text-decoration: none;
      }

      &:after {
        background-image: url(~@/assets/images/icon-arrow-right-gray.svg);
        width: 1.2rem;
        height: 0.9rem;

        @include desktop-up {
          width: 1.9rem;
          height: 1.5rem;
        }
      }

      p {
        margin: 2rem 0;

        @include desktop-up {
          margin: 1rem 0;
        }
      }
    }
  }

  &__level {
    &--green {
      background-color: $alert-green;
    }

    &--blue {
      background-color: $alert-blue;
    }

    &--yellow {
      background-color: $alert-yellow;
    }

    &--orange {
      background-color: $alert-orange;
    }

    &--red {
      background-color: $alert-red;
      color: $white;
      .c-alert {
        &__button {
          background-image: url(~@/assets/images/icon-info-light.svg);
        }
        &__content {
          .c-button {
            &:after {
              background-image: url(~@/assets/images/icon-arrow-right-white.svg);
            }
          }
        }
      }
    }
  }

  .c-cta--secondary {
    flex: 0 0 16rem;
    margin: 1rem 1rem 1rem 0rem;
    color: $gray;
    border-left-color: $gray;
    @include desktop-up {
      margin: 0 1rem 1rem 2.5rem;
    }
    &:hover {
      &:after {
        left: 1rem;
      }
    }
    &:after {
      background-image: url(~@/assets/images/icon-arrow-right-gray.svg);
    }
  }
}
</style>
